export const SYSTEM_MARKERS = [
  "Agent Description:",
  "ORCHESTRATION PROTOCOL:",
  "ROLE You are",
  "SOURCES OF TRUTH",
  "SUB-AGENT ROUTING",
];

export const MIN_SYSTEM_LENGTH = 500;
export const DEDUP_KEY_LENGTH = 120;
export const MAX_STRING_LENGTH = 200;
export const MAX_DISPLAY_VALUE_LENGTH = 80;
export const MAX_OBJECT_KEYS_PREVIEW = 3;

export const REASONING_PREFIX_PATTERNS = [
  /^\[\s*\{\s*text\s*=\s*ROLE\s*/i,
  /^\[\s*\{\s*text\s*=\s*\w*\s*/i,
  /^\{\s*"system"\s*:\s*"\s*Agent Description:\s*ROLE\s*/i,
];

export const STRUCTURE_TAG_COLORS: Record<string, string> = {
  a: "#9c27b0",
  b: "#2196f3",
  c: "#00bcd4",
  d: "#4caf50",
  e: "#8bc34a",
  f: "#cddc39",
  g: "#ffeb3b",
  h: "#ffc107",
  i: "#ff9800",
  j: "#ff5722",
  k: "#795548",
  l: "#607d8b",
  m: "#e91e63",
  n: "#3f51b5",
  o: "#009688",
  p: "#673ab7",
  q: "#f44336",
  r: "#00acc1",
  s: "#7e57c2",
  t: "#26a69a",
  u: "#ef5350",
  v: "#ab47bc",
  w: "#5c6bc0",
  x: "#42a5f5",
  y: "#ffa726",
  z: "#66bb6a",
  _: "#78909c",
  DIGIT_0: "#90a4ae",
};

export const DEFAULT_TAG_COLOR = "#757575";

export const STRUCTURE_INDENT_MULTIPLIER = 14;
export const STRUCTURE_INDENT_BASE = 4;
export const STRUCTURE_DEPTH_MAX = 30;

export const JSON_STRINGIFY_INDENT = 2;

export const DRAWER_Z_INDEX_OFFSET = 10;
